import { FilePDF } from '@unified-checkout/design-system/icons/index';

import type { IRejectionCardProps } from '@app/dashboard/types/innerLayout/home/onboarding/modals';

import styles from './rejection-card.module.scss';

const RejectionCard = ({ title, descriptions }: IRejectionCardProps) => {
  return (
    <div className={styles['updates-required-modal__content__card']}>
      <div className={styles['updates-required-modal__content__card__icon']}>
        {FilePDF}
      </div>
      <div className={styles['updates-required-modal__content__card__body']}>
        <p
          className={
            styles['updates-required-modal__content__card__body__title']
          }
        >
          {title}
        </p>
        {descriptions.map((description) => (
          <p
            key={description}
            className={
              styles['updates-required-modal__content__card__body__subtitle']
            }
          >
            {description}
          </p>
        ))}
      </div>
    </div>
  );
};

export default RejectionCard;
